module.exports = __webpack_public_path__ + "static/media/wearable.b8ac7e62.jpg";